import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useChargePointChannelContext } from '../../charge-point.context';

export const ChargePointChannelDeleteFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const channel = useChargePointChannelContext();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <>
        <Text bold>
          {t('$.charge-point-channel-delete.step-1.confirm', {
            qrCode: channel.qrCode,
          })}
        </Text>
        <Text italic>{t('$.charge-point-channel-delete.step-1.warning')}</Text>
      </>
    );
  };
